var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealsHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.800049 2.29985C0.800049 1.63711 1.33731 1.09985 2.00005 1.09985H20C20.6628 1.09985 21.2001 1.63711 21.2001 2.29985V24.2999C21.2001 24.9626 20.6628 25.4999 20 25.4999H2.00005C1.33731 25.4999 0.800049 24.9626 0.800049 24.2999V2.29985ZM2.00005 1.99985C1.83436 1.99985 1.70005 2.13417 1.70005 2.29985V24.2999C1.70005 24.4655 1.83436 24.5999 2.00005 24.5999H20C20.1657 24.5999 20.3 24.4655 20.3 24.2999V2.29985C20.3 2.13417 20.1657 1.99985 20 1.99985H2.00005Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 7.49985V6.59985H18.2V7.49985H10.8Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 11.4999V10.5999H15.2V11.4999H10.8Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 15.4999V14.5999H18.2V15.4999H10.8Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 19.4999V18.5999H14.2V19.4999H10.8Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20005 8.29985C9.20005 9.51488 8.21508 10.4999 7.00005 10.4999C5.78502 10.4999 4.80005 9.51488 4.80005 8.29985C4.80005 7.08483 5.78502 6.09985 7.00005 6.09985C8.21508 6.09985 9.20005 7.08483 9.20005 8.29985ZM7.00005 9.59985C7.71802 9.59985 8.30005 9.01782 8.30005 8.29985C8.30005 7.58188 7.71802 6.99985 7.00005 6.99985C6.28208 6.99985 5.70005 7.58188 5.70005 8.29985C5.70005 9.01782 6.28208 9.59985 7.00005 9.59985Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.45 13.4999H9.55002V13.2999C9.55002 12.945 9.33435 12.5685 8.87173 12.2601C8.81458 12.222 8.75422 12.1854 8.69082 12.1505C8.24579 11.9058 7.6574 11.7499 7.00002 11.7499C6.18533 11.7499 5.48058 11.9891 5.02125 12.336C4.68014 12.5937 4.49861 12.8888 4.45866 13.1756C4.45291 13.2169 4.45002 13.2583 4.45002 13.2999V13.4999H3.54993L3.55002 13.2982C3.55021 13.1037 3.5814 12.9163 3.63891 12.7384C3.78305 12.2923 4.08999 11.9115 4.4788 11.6179C4.55907 11.5572 4.6434 11.4998 4.73138 11.4457C5.34584 11.068 6.14403 10.8499 7.00002 10.8499C7.90492 10.8499 8.74448 11.0936 9.37096 11.5112C9.60607 11.668 9.81591 11.8529 9.98682 12.0626C10.0941 12.1941 10.1862 12.3356 10.2594 12.4861C10.2991 12.5676 10.3333 12.6518 10.3612 12.7384C10.3914 12.8318 10.4143 12.9278 10.4293 13.0263C10.443 13.1158 10.45 13.207 10.45 13.2999V13.4999Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8 2.09985L23.7 2.09985L23.7 24.4999L22.8 24.4999L22.8 2.09985Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55005 13.0999H10.45V13.9999H3.55005V13.0999Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealsHover);
export default __webpack_public_path__ + "static/media/deals-hover.4354d512.svg";
export { ForwardRef as ReactComponent };